module.exports = __webpack_public_path__ + "img/licenseHold.66a65edf.png";